const FIRST_HOST = process.env.VUE_APP_CALENDLY_RECRUITMENT_PATH_FIRST;
const SECOND_HOST = process.env.VUE_APP_CALENDLY_RECRUITMENT_PATH_SECOND;
const EXTRA_HOST = process.env.VUE_APP_CALENDLY_RECRUITMENT_PATH_EXTRA;
const WAREHOUSE_CORE_HOST =
  process.env.VUE_APP_CALENDLY_RECRUITMENT_PATH_WAREHOUSE_CORE;
const WAREHOUSE_EXTRA_HOST =
  process.env.VUE_APP_CALENDLY_RECRUITMENT_PATH_WAREHOUSE_EXTRA;
const PATRAS_CORE_HOST = process.env.VUE_APP_CALENDLY_PATRAS_CORE_HOST;
const IRAKLEIO_CORE_HOST = process.env.VUE_APP_CALENDLY_IRAKLEIO_CORE_HOST;

export const assignRandomUrlInterviewHost = (
  isEmploymentTypeExtra,
  isWarehouse,
  cityId
) => {
  if (isEmploymentTypeExtra && !isWarehouse) {
    return EXTRA_HOST;
  }
  if (isEmploymentTypeExtra && isWarehouse) {
    return WAREHOUSE_EXTRA_HOST;
  }
  if (!isEmploymentTypeExtra && isWarehouse) {
    return WAREHOUSE_CORE_HOST;
  }
  if (!isEmploymentTypeExtra && !isWarehouse && cityId === 3) {
    return PATRAS_CORE_HOST;
  }
  if (!isEmploymentTypeExtra && !isWarehouse && cityId === 6) {
    return IRAKLEIO_CORE_HOST;
  }

  // const isFirst = Math.random() < 0.5;
  const isFirst = Math.random() < 0; // temporary select second host
  return isFirst ? FIRST_HOST : SECOND_HOST;
};
